var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37115 0 0 5.37115 0 12C0 18.6288 5.37115 24 12 24C18.6288 24 24 18.6288 24 12C24 5.37115 18.6288 0 12 0ZM10.1481 16.2519C10.0096 16.3904 9.81346 16.5058 9.64038 16.5058C9.46731 16.5058 9.27115 16.3846 9.12692 16.2462L5.89615 13.0154L6.92308 11.9885L9.64615 14.7115L16.8462 7.45962L17.8558 8.50385L10.1481 16.2519Z",
    fill: "#75D99D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircle);
export default __webpack_public_path__ + "static/media/checked-circle.9306f2d66784ddab22e36c25ef542d93.svg";
export { ForwardRef as ReactComponent };